import { useQuery } from '@tanstack/react-query';
import { fetchPublicProduct, fetchPublicProducts, type Product, type ProductCategory } from '@/api/products';
import { queryKeys } from '@/api/queryKeys';

export const usePublicProducts = () =>
  useQuery({ queryKey: queryKeys.publicProducts, queryFn: fetchPublicProducts, staleTime: 5 * 60_000 });

export const usePublicProduct = (slug: string | undefined) =>
  useQuery({
    queryKey: queryKeys.publicProduct(slug ?? ''),
    queryFn: () => fetchPublicProduct(slug as string),
    enabled: Boolean(slug),
    staleTime: 5 * 60_000
  });

export const PUBLIC_CATEGORY: Record<ProductCategory, { title: string; anchor: string; lead: string }> = {
  BED: {
    title: 'Elektromos betegágyak',
    anchor: 'agyak',
    lead: 'Távirányítóval állítható magasság, háttámla és lábrész. Házhoz visszük és összeszereljük.'
  },
  MATTRESS: {
    title: 'Matracok',
    anchor: 'matracok',
    lead: 'Minden matracot minden bérlés után kimosatunk és fertőtlenítünk.'
  },
  ACCESSORY: {
    title: 'Betegápolási segédeszközök',
    anchor: 'kiegeszitok',
    lead: 'Az ágy mellé, egy rendelésben, egy címre, egy szállítási díjjal.'
  }
};

export const CATEGORY_ORDER: ProductCategory[] = ['BED', 'MATTRESS', 'ACCESSORY'];

export const groupByCategory = (products: Product[]): { category: ProductCategory; items: Product[] }[] =>
  CATEGORY_ORDER.map((category) => ({ category, items: products.filter((product) => product.category === category) })).filter(
    (group) => group.items.length > 0
  );

export const specificationEntries = (specifications: Record<string, unknown> | null): [string, string][] => {
  if (!specifications) return [];

  return Object.entries(specifications)
    .map<[string, string]>(([label, value]) => [label, Array.isArray(value) ? value.join(', ') : String(value)])
    .filter(([, value]) => value.trim().length > 0);
};
